import { useQuery } from "@tanstack/react-query";
import { transactionApi } from "@bw/shared/api";
import type { PlayerTransactionReceiptResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's payment history (GET /transactions/history), SERVER-SCOPED to the
 * auth user — the page never passes its own uid. The server returns newest-first;
 * the page renders the server's order and does NOT re-sort.
 */
export function useTransactionHistory() {
  return useQuery<PlayerTransactionReceiptResponse[]>({
    queryKey: queryKeys.me.transactions(),
    queryFn: () => transactionApi.getHistory(),
  });
}
